import {Building2} from 'lucide-react'
import {Button} from '@/components/ui/button'
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import {useTheme} from '@/contexts/theme-context'
import {useI18n} from '@/i18n'
import {isTenantMode} from '@/lib/runtime-config'

const BRAND_VALUES = ['lumon', 'swiss', 'muenchenstift', 'bundesdruckerei', 'aargau', 'default'] as const

export function BrandThemeToggle() {
    const i18n = useI18n()
    const {brandTheme, setBrandTheme} = useTheme()
    if (isTenantMode()) return null

    const brandLabels: Record<string, string> = {
        lumon: i18n.brandTheme.lumon,
        swiss: i18n.brandTheme.swiss,
        muenchenstift: i18n.brandTheme.muenchenstift,
        bundesdruckerei: i18n.brandTheme.bundesdruckerei,
        aargau: i18n.brandTheme.aargau,
        default: i18n.brandTheme.default,
    }

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="ghost" size="sm" className="gap-2" data-testid="btn-brand-theme">
                    <Building2 className="h-4 w-4"/>
                    <span className="hidden sm:inline">{brandLabels[brandTheme]}</span>
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
                {BRAND_VALUES.map((value) => (
                    <DropdownMenuItem
                        key={value}
                        onClick={() => setBrandTheme(value)}
                        className={brandTheme === value ? 'bg-accent' : ''}
                    >
                        {brandLabels[value]}
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    )
}
